import React from 'react';
import { AlertTriangle, LogOut, RefreshCw } from 'lucide-react';

import { reportRuntimeError } from '../services/runtimeLogger';

class DashboardErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportRuntimeError(error, {
      kind: 'react.error_boundary',
      boundary: this.props.boundaryName || 'dashboard',
      componentStack: errorInfo?.componentStack,
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-orange-50 px-4 py-10">
        <div className="mx-auto max-w-2xl rounded-[2rem] border border-red-100 bg-white p-8 shadow-[0_30px_80px_-40px_rgba(220,38,38,0.35)]">
          <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-red-100 text-red-600">
            <AlertTriangle className="h-8 w-8" />
          </div>
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-red-500">Incident interface</p>
          <h1 className="mt-3 text-3xl font-bold text-gray-900">Le dashboard a rencontré une erreur.</h1>
          <p className="mt-3 text-base leading-7 text-gray-600">
            L’erreur a été enregistrée automatiquement pour diagnostic. Tu peux recharger la page ou te reconnecter.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <button
              type="button"
              onClick={this.handleReload}
              className="inline-flex h-12 items-center rounded-2xl bg-gray-950 px-5 text-sm font-semibold text-white transition hover:bg-gray-800"
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              Recharger la page
            </button>
            <button
              type="button"
              onClick={this.props.onLogout}
              className="inline-flex h-12 items-center rounded-2xl border border-gray-200 px-5 text-sm font-semibold text-gray-700 transition hover:bg-gray-50"
            >
              <LogOut className="mr-2 h-4 w-4" />
              Se reconnecter
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardErrorBoundary;